import {ApiAuthRequestInterface} from "../authentication/BuildAuthRequestInterface"
import {GetAuthToken} from "../storage/AuthToken";


function AsyncProblemAuthBuilder(): ApiAuthRequestInterface{
  return {
    api_version: '1.0',
    Agent: 'Chrome',
    IsMarketPlace: 'true',
    auth_token: GetAuthToken() || "",
  };
}
export function BuildFetchRequest(body?: string, method?: string): RequestInit {
  const authDetails = AsyncProblemAuthBuilder();
  return {
    method: method ? method : body ? 'post' : 'get',
    credentials: 'omit',
    headers: new Headers({
      'auth_token': authDetails?.auth_token,
      'IsMarketPlace': authDetails.IsMarketPlace,
      'Agent': authDetails.Agent,
      'api_version' :authDetails.api_version,

      'Accept': 'application/json',
      'Content-Type': 'application/json',
  }),
  body
}}
